import { render, staticRenderFns } from "./UserCardExtension.vue?vue&type=template&id=76030ee2"
import script from "./UserCardExtension.ts?vue&type=script&lang=ts&external"
export * from "./UserCardExtension.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports